import React from 'react';
import { withAuthenticationRequired } from 'react-oidc-context';
import { Outlet } from 'react-router';
import Loader from './01_atoms/Loader/Loader';
import Centered from './01_atoms/Centered/Centered';

export default withAuthenticationRequired(Outlet, {
  OnRedirecting() {
    return (
      <main>
        <Centered>
          <span>U wordt doorgestuurd naar de login pagina</span>
          <Loader />
        </Centered>
      </main>
    );
  },
});

